module.exports = __webpack_public_path__ + "static/media/28a.b1c696c7.jpg";